export default "__VITE_ASSET__DFXGjKZZ__"